import { makeStyles } from "@material-ui/core/styles";
import transitions from "@material-ui/core/styles/transitions";
import zIndex from "@material-ui/core/styles/zIndex";
import { HowToVoteRounded } from "@material-ui/icons";
import { FaAlignCenter } from "react-icons/fa";
import { head } from "underscore";

export const StylesServiceCard = makeStyles((theme) => ({

    roundedCard: {
        borderRadius: "2em",
        backgroundColor: "#F3F2F2",
        height: "13em",
        marginLeft: "auto",
        marginRight: "auto",
        width: "100%",
    },
    roundedCardFlipped: {
        borderRadius: "2em",
        backgroundColor: "#002e6a",
        height: "13em",
        marginLeft: "auto",
        marginRight: "auto",
        cursor: 'pointer',

    },
    roundedCardHover: {
        borderRadius: "2em",
        backgroundColor: "#FFFFFF",
        height: "13em",
        marginLeft: "auto",
        marginRight: "auto",
    },
    roundedCardGrid: {
        width: "80%",
        display: "flex",
    },
    roundedCardSubscribed: {
        borderRadius: "2em",
        backgroundColor: "#FFCD00",

    },
    backgroundChange: {
        padding: "16px 0px 0px 0px",


    },
    backgroundChangeHover: {
        padding: "16px 0px 0px 0px",
    },
    backgroundFlipped: {
        padding: "16px 0px 0px 0px",
        backgroundColor: "#002e6a",
        cursor: 'pointer',
        width: "100%",
    },

    serviceNameContainer: {
        textAlign: "center",
        color: "#002e6a",

    },
    serviceName: {
        textAlign: "center",
        color: "#002e6a",
        cursor: 'pointer',
        "&:last-child": {
            paddingBottom: "0"
        },
        maxWidth: "100%"

    },
    serviceNameHover: {
        textAlign: "center",
        color: "white",
        "&:last-child": {
            paddingBottom: "0"
        },
    },

    details: {
        display: "flex",
        flexDirection: "column",
    },
    media: {
        maxWidth: "10rem",
    },
    imgCardMedia: {
        width: "auto",
        height: "4em",
        float: "left",
    },
    ButtonRight: {
        textAlign: "center",
        float: "right",
    },
    ButtonLeft: {
        textAlign: "center",
        float: "left",
    },
    ButtonLeftPermission: {
        textAlign: "center",
        float: "left",
        marginTop: "1em",
        marginLeft: "auto",
        marginRight: "auto"

    },
    ButtonCenter: {
        textAlign: "center",
        float: "center",
        color: "#666666",
        border: "none"
    },

    GridContent: {
        marginLeft: "0.25em",
        marginRight: "0.25em",
    },
   
    GridButtons: {
        marginLeft: "0.25em",
        marginRight: "0.25em",
        marginTop: "1em",
    },
    GridButtonsEnterprise: {
        justifyContent: "center",
    },
    CardDescription: {
        textAlign: "center",
        color: "white",
        paddingTop: "1px",
        padding: "12px 12px 0px 12px",
    },

    
    flipCard: {
        width: "100%",
        height: "100%",
    },

    flipCardInner: {
        position: "relative",
        width: "100%",
        height: "100%",
        transformStyle: "preserve-3d",
        transition: "transform 0.8s",
    },

    flipCardFront: {
        position: "absolute",
        backfaceVisibility: "hidden",
        WebkitBackfaceVisibility: "hidden",
        zIndex: 2,
    },

    flipCardBack: {
        poisition: "absolute",
        zIndex: 1,
        backfaceVisibility: "hidden",
        WebkitBackfaceVisibility: "hidden",
        transform: "rotateY(180deg)",
    },

    flipped: {
        transform: "rotateY(180deg)",
    }

}));
